import React, { useState } from 'react'
import Fetch from '@lib/fetch'

const ResendConfirmation = ({ email }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)

  const handleResend = async () => {
    setIsSubmitting(true)
    setError(null)

    try {
      const response = await Fetch('/mailing-list/resend', {
        method: 'POST',
        body: JSON.stringify({ email })
      })

      const data = await response.json()

      if (data.success) {
        setSuccess(true)
      } else {
        setError('Failed to resend confirmation email. Please try again.')
      }
    } catch (err) {
      console.error('Resend failed:', err)
      setError('An error occurred. Please try again.')
    } finally {
      setIsSubmitting(false)
    }
  }

  if (success) {
    return (
      <div className="mt-4 p-4 bg-green-50 dark:bg-green-900 dark:bg-opacity-20 rounded-lg">
        <p className="text-green-700 dark:text-green-300">
          A new confirmation email has been sent. Please check your inbox.
        </p>
      </div>
    )
  }

  return (
    <div className="mt-4">
      {error && (
        <p className="text-red-600 dark:text-red-400 mb-2">{error}</p>
      )}
      <button
        onClick={handleResend}
        disabled={isSubmitting}
        className="px-6 py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSubmitting ? 'Sending...' : 'Resend Confirmation Email'}
      </button>
    </div>
  )
}

export default ResendConfirmation
